import { team, teams, conceptTeam } from "./Teams";
import { resources } from "./Resources";

export const Query = {
  team,
  teams,
  concept: conceptTeam
};
